<template>
  <item-div
    :tooltipstr="$t('tooltip.tx.inputData')"
    :title="$t('txDetail.inputData.title')"
  >
    <textarea
      readonly
      spellcheck="false"
      rows="5"
      wrap="hard"
      v-if="inputDataViewType !== INPUTDATA_VIEW_TYPE.decode"
      :class="{
        'input-data': true,
        'input-data--nodata': noInputData
      }"
      :value="inputData"
    >
    </textarea>
    <div class="input-data-decode" v-else>
      <table class="table">
        <thead>
          <tr>
            <th style="width:5%;">#</th>
            <th width="160" v-if="canDecodeName">
              {{ $t("txDetail.inputData.name") }}
            </th>
            <th width="120">{{ $t("txDetail.inputData.type") }}</th>
            <th>{{ $t("txDetail.inputData.data") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in inputData" :key="index">
            <td>{{ index }}</td>
            <td v-if="canDecodeName">{{ item.name }}</td>
            <td>{{ item.key }}</td>
            <td>
              <div
                v-for="(v, index) in item.value"
                :key="index"
                :class="{ 'mb-3': index !== item.value.length - 1 }"
              >
                <span
                  v-if="isAddress(item.key)"
                  class="click-able"
                  @click="goAddress(v)"
                >
                  {{ v }}
                </span>
                <span v-else>
                  {{ normalize(v) }}
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="input-data-command" ref="dropdownMenu">
      <div v-if="inputDataViewType !== INPUTDATA_VIEW_TYPE.decode">
        <span class="btn" :class="{ show: show }" @click="show = !show">
          {{ $t("txDetail.inputData.viewType") }}
          <img
            src="../../assets/images/address/chevron-down.svg"
            width="12.11"
            height="6.92"
            class="address-op-btn"
          />
        </span>
        <transition name="slide-fade">
          <div class="dropdown" v-show="show">
            <div
              v-for="(label, key) in {
                [INPUTDATA_VIEW_TYPE.default]: $t(
                  'txDetail.inputData.defaultView'
                ),
                [INPUTDATA_VIEW_TYPE.utf8]: $t('txDetail.inputData.utf8View'),
                [INPUTDATA_VIEW_TYPE.raw]: $t('txDetail.inputData.originalView')
              }"
              :key="key"
              class="dropdown-item"
              :class="{ 'dropdown-item-current': key === inputDataViewType }"
              @click="handleInputDataCommand(key)"
            >
              {{ label }}
            </div>
          </div>
        </transition>
      </div>
      <span
        class="btn"
        @click="handleInputDataDecodeCommand"
        v-if="inputDataSignature"
      >
        {{
          inputDataViewType === INPUTDATA_VIEW_TYPE.decode
            ? $t("txDetail.inputData.switchBack")
            : $t("txDetail.inputData.decode")
        }}
      </span>
    </div>
  </item-div>
</template>
<script>
import { ethers } from "ethers";
import $httpService from "../../common/utils";
import itemDiv from "../common/DetailItemH";

const INPUTDATA_VIEW_TYPE = {
  raw: "raw",
  default: "default",
  utf8: "utf8",
  decode: "decode"
};

export default {
  name: "inpuData",
  components: {
    itemDiv
  },
  props: {
    goAddress: Function
  },
  data() {
    return {
      show: false,
      inputDataRawView: "",
      inputDataSignature: "",
      inputDataViewType: INPUTDATA_VIEW_TYPE.default,
      hasABI: false,
      isEVM: false,
      info: {}
    };
  },
  computed: {
    noInputData() {
      return !this.inputDataRawView || this.inputDataRawView === "0x";
    },
    canDecodeName() {
      if (!this.inputDataDecodeView) return false;
      return this.inputDataDecodeView.some(
        item => typeof item.name !== "undefined"
      );
    },
    inputDataDefaultView() {
      if (this.noInputData) {
        return this.inputDataRawView;
      }

      if (this.isEVM) {
        const raw = this.inputDataRawView;
        let str = `Function: ${this.inputDataSignature}

MethodID: ${raw.slice(0, 10)}`;

        let i = 0;
        while (i < Math.floor(raw.length / 64)) {
          str += `\n[${i}]:  ${raw.slice(i * 64 + 10, (i + 1) * 64 + 10)}`;
          i++;
        }
        return str;
      } else {
        const raw = this.info.default_view;
        if (!raw) return this.inputDataRawView;
        let str = `Function: ${raw.function}

MethodID: ${raw.method_id}`;

        let i = 0;
        while (i < raw.params.length) {
          str += `\n[${i}]:  ${raw.params[i]}`;
          i++;
        }
        return str;
      }
    },
    inputDataUtf8View() {
      return Ont.utils.hexstr2str(this.inputDataRawView);
    },
    inputDataDecodeView() {
      if (this.isEVM) {
        const code = this.inputDataSignature;
        if (!this.inputDataSignature) return "";
        const left_paren_pos = code.indexOf("(");
        const right_paren_pos = code.indexOf(")");
        const fun_body = code.slice(left_paren_pos + 1, right_paren_pos);
        const keys = fun_body.split(",").map(item => item.trim());
        const values = ethers.utils.defaultAbiCoder.decode(
          keys,
          ethers.utils.hexDataSlice(this.inputDataRawView, 4)
        );
        const result = [];
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i].split(" ");
          result.push({
            key: key[0],
            name: key[1],
            value: Array.isArray(values[i]) ? values[i] : [values[i]]
          });
        }
        return result;
      }
      const decode = this.info.decode;
      if (!decode) return "";
      return decode.map(item => {
        return {
          key: item.type,
          name: item.name,
          value: item.data
        };
      });
    },
    inputData() {
      const handlerMap = {
        [INPUTDATA_VIEW_TYPE.default]: this.inputDataDefaultView,
        [INPUTDATA_VIEW_TYPE.raw]: this.inputDataRawView,
        [INPUTDATA_VIEW_TYPE.utf8]: this.inputDataUtf8View,
        [INPUTDATA_VIEW_TYPE.decode]: this.inputDataDecodeView
      };
      return handlerMap[this.inputDataViewType];
    }
  },
  methods: {
    async init() {
      const { result } = await $httpService.get(
        `/transactions/input-data/${this.$route.params.tx_hash}`
      );
      this.info = result;
      this.inputDataRawView = result.original_view;
    },
    async getSignature() {
      if (this.noInputData) return;
      if (!this.isEVM) {
        if (!!this.info.default_view) {
          this.inputDataSignature = this.info.default_view.function;
        }
        return;
      }
      if (this.hasABI) {
        const { Interface, FormatTypes } = ethers.utils;
        try {
          const iface = new Interface(this.info.abi);
          const functionFragment = iface.getFunction(
            this.inputDataRawView.slice(0, 10)
          );
          this.inputDataSignature = functionFragment.format(FormatTypes.full);
          return;
        } catch (error) {
          console.error(error);
        }
      }
      this.inputDataSignature = await $httpService.get(
        `https://raw.githubusercontent.com/ethereum-lists/4bytes/master/signatures/${this.inputDataRawView.slice(
          2,
          10
        )}`
      );
    },
    handleInputDataCommand(type) {
      this.inputDataViewType = type;
      this.show = false;
    },
    handleInputDataDecodeCommand() {
      this.handleInputDataCommand(
        this.inputDataViewType === INPUTDATA_VIEW_TYPE.decode
          ? INPUTDATA_VIEW_TYPE.default
          : INPUTDATA_VIEW_TYPE.decode
      );
    },
    documentClick({ target }) {
      const el = this.$refs.dropdownMenu;
      if (!el) return;
      if (el !== target && !el.contains(target)) {
        this.show = false;
      }
    },
    isAddress(key) {
      return (
        key === "address" ||
        key === "address[]" ||
        key === "Address" ||
        key === "Address[]"
      );
    },
    normalize(x) {
      if (typeof x !== "number") {
        return x;
      }
      if (Math.abs(x) < 1.0) {
        var e = parseInt(x.toString().split("e-")[1]);
        if (e) {
          x *= Math.pow(10, e - 1);
          x = "0." + new Array(e).join("0") + x.toString().substring(2);
        }
      } else {
        var e = parseInt(x.toString().split("+")[1]);
        if (e > 20) {
          e -= 20;
          x /= Math.pow(10, e);
          x += new Array(e + 1).join("0");
        }
      }
      return x;
    }
  },
  async created() {
    this.INPUTDATA_VIEW_TYPE = INPUTDATA_VIEW_TYPE;
    await this.init();
    this.isEVM = typeof this.info.abi !== "undefined";
    this.hasABI = this.isEVM && !!this.info.abi && this.info.abi !== "{}";
    this.getSignature();
    document.addEventListener("click", this.documentClick);
  },
  destroyed() {
    document.removeEventListener("click", this.documentClick);
  }
};
</script>

<style lang="less" scoped>
.input-data {
  width: 100%;
  height: 140px;
  background: #fafafa;
  font-size: 14px;
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono,
    Courier New, monospace;
  color: #000000;
  resize: vertical;
  border: none;
  outline: none;
  padding: 20px;
  box-sizing: border-box;
  word-break: break-all;
  &--nodata {
    height: 60px;
  }
}

.input-data-command {
  display: flex;
  column-gap: 40px;
  margin-top: 20px;
  position: relative;
  font-family: "Avenir";
  font-weight: 500;
  font-size: 14px;
}

.btn {
  cursor: pointer;
  font-weight: 500;

  > img {
    transition: all 0.3s ease;
    vertical-align: middle;
    margin-left: 16px;
    user-select: none;
  }

  &.show img {
    transform: rotateZ(180deg);
  }
  &:hover {
    opacity: 0.6;
  }
}

.dropdown {
  position: absolute;
  z-index: 1;
  width: 116px;
  left: 0;
  top: 30px;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
}

.dropdown-item {
  cursor: pointer;
  padding: 10px;
  font-weight: 500;

  &:hover,
  &.dropdown-item-current {
    background-color: #fafafa;
    color: rgba(0, 0, 0, 0.6);
  }
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
}

.input-data-decode {
  overflow: auto;
  max-height: 170px;
  font-size: small;
  font-family: monospace;
  background-clip: padding-box;
  border: 1px solid #d5dae2;
  border-radius: 0.25rem;
  position: relative;
  > table {
    width: 100%;
    table-layout: fixed;
    tr:hover {
      color: rgb(30, 32, 34);
      background-color: #fafafa;
    }
    th,
    td {
      white-space: nowrap;
      vertical-align: top;
      border-top: 1px solid #f2f2f2;
      padding: 5px;
    }
    th {
      vertical-align: bottom;
      background-color: #fafafa;
    }
  }

  .mb-3 {
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/transaction/InputData.vue